import { render, staticRenderFns } from "./AboDBSecureParameters.vue?vue&type=template&id=4cdb1ad9&scoped=true"
import script from "./AboDBSecureParameters.vue?vue&type=script&lang=js"
export * from "./AboDBSecureParameters.vue?vue&type=script&lang=js"
import style0 from "./AboDBSecureParameters.vue?vue&type=style&index=0&id=4cdb1ad9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb1ad9",
  null
  
)

export default component.exports